import * as ReferralMessage from "./referral-messages.js";

/**
 * Message
 */
 export const Message = (function () {
  // GLOBAL VARIABLES
  let messageSentCount = 0; //used in adding ticks to sent messages
  let latestMessageID = 0; //most recent message displayed
  let oldestMessageID = 0; //oldest message displayed
  let alertOldestMessage = false; //alerts when oldest message has been reach (on scrolling up)
  let gettingNewMessages; //stores the polling for new messages
  let app;
  let user;
  let messageObject; //for storing the message object for the context in which messaging is occurring

  let init =  function () { 

    //event that loads messages
    $(".message-event-handler").on("click", function () {
      
      //set the apps that the messaging is taking place across - this is used to filter the messages in a persons PDS
      app = $(".messages").data('app');
      user = $(".messages").data('user');

      //handles for messaging within different contexts e.g. a referral
      switch($(".messages").attr('id')) {
        case "referral-messages":
          messageObject = ReferralMessage.getMessageObject(app, user);
          break;
        case "service-messages":
          //TODO set all required variables for a service
          break;
        default:
          Util.toggleAlert('#error-message', "No context for messaging has been passed", 'alert-warning');
      }

      loadExistingMessages(); 
      $("#recipient-name").text(messageObject.recipientName);
      //polls for new messages every 3 seconds
      gettingNewMessages = setInterval(getNewMessages,3000);

    });

    //gets older messages when scrolled to the top
    $('.messages').on("scroll", function() {
      if ($('.messages').scrollTop() == 0 && !alertOldestMessage) {
        $('.messages').animate({
          scrollTop: 55
        }, 'slow');
        $('.messages').css("overflow-y", "hidden");

        loadOlderExistingMessages();
      }
    });

    //checks if scrolled to the bottom to read a new message and removes alert message
    $('.messages').on("scroll", function() {
      let scrollPosition = $(".messages").prop("scrollHeight") - $(".messages").prop("clientHeight") - $(".messages").prop("scrollTop");
      if (scrollPosition == 0 && !$('#new-message-alert').hasClass("d-none")) {
        $('#new-message-alert').addClass("d-none");    
      }
    });

    $('form.chat input[type="submit"]').on("click", function(event) {
      event.preventDefault();
      const message = $('form.chat textarea').val();

      if (message.trim().length > 0) {
        const date = getFormattedDate(new Date());
        const dateToPost = Date.now().toString().slice(0, -3);
    
        disableSubmit();
        sendMessage(message, dateToPost);
        appendSentMessage(date, message, messageSentCount);
        
      }

      $('form.chat textarea').val('');
      $('.messages').scrollTop($('.messages').prop("scrollHeight"));
    });

    $('#messages-chat-view').on('hidden.bs.modal', function (e) {
      $('.messages').html('');
      alertOldestMessage = false;
      clearInterval(gettingNewMessages);
    });
  }

  /**
   * Handles functionality for loading existing messages when the message modal is firt opened
   * calls helper function getMessages() that handles the various ajax requests.
   */
  function loadExistingMessages() {
    $.when(
      getMessages(true, "newest", 8)
    ).done(function(response) {
      if(response.messages == "Start a new conversation here.") {
        $('form.chat div.messages').append('<div id="conversation-starter" class="text-center"><p>' + response.messages + '</p></div>');
      } else {
        $(response.messages).each(function(index, element) {
          displayMessage(element, response.me); 
        });
        latestMessageID = response.latestMessageID;
        oldestMessageID = response.oldestMessageID;
      }
      
      $('#messages-chat-view').modal('show');

      $('#messages-chat-view').on('shown.bs.modal', function () {
        $('.messages').scrollTop($('.messages').prop("scrollHeight"));
      });

    }).fail(function(error) {
        Util.toggleAlert('#error-message', error.message, 'alert-warning');
    });
  }

  /**
   * Handles functionality for loading older existing messages when scrolling up
   * calls helper function getMessages() that handles the various ajax requests.
   */
  function loadOlderExistingMessages() {

    $.when(
      getMessages(true, "older", 5)
    ).done(function(response) {
      let messages = response.messages;
      if (messages == "You have no older messages.") {
        if (!alertOldestMessage) {
          $('form.chat div.messages').prepend('<div id="no-older-messages" class="text-center"><p>' + messages + '</p></div>');
          alertOldestMessage = true;
        } 
      } else {
        messages.reverse();
        $(messages).each(function(index, element) {
          displayMessage(element, response.me, true);
        });
        oldestMessageID = response.oldestMessageID;
      }
      $('.messages').css("overflow-y", "scroll");
    }).fail(function(error) {
        Util.toggleAlert('#error-message', error.message, 'alert-warning');
        $('.messages').css("overflow-y", "scroll");
    });
  }

   /**
   * Handles functionality for getting new messages 
   * calls helper function getMessages() that handles the various ajax requests.
   */
   function getNewMessages() {
    
    $.when(
      getMessages(false, "", null)
    ).done(function(response) {
      if (response.message == "You have new messages to read.") {
        let scrollPositionBottom = ($(".messages").prop("scrollHeight") - $(".messages").prop("clientHeight") - Math.ceil($(".messages").prop("scrollTop")) == 0);
          $(response.latestMessages).each(function(index, element) {
            displayMessage(element, " ");
            latestMessageID = element['id'];
            if (scrollPositionBottom) {
              $('.messages').animate({
                scrollTop: $(".messages").prop("scrollHeight") 
              }, 'slow');
            } else {
              $('#new-message-alert').removeClass("d-none");
            }
    
          });
        }
      }
    ).fail(function(error) {
      Util.toggleAlert('#error-message', error.message, 'alert-warning');
    })
  }
  /**
   * Ajax request, handles getting messages either from a citizen's PDS or the inapp dataset of
   * a service provider
   * @param {string} type determines the type of messages to be returned. 1 of 3 options:
   * "newest existing"
   * "older existing"
   * "new"
   * @returns 
   */
  let getMessages = function(existing, context, noOfMessages) {
   
    let url = "";

    if (existing) { //gets any already existing messages

      url = messageObject.myGetExistingMessages;
      messageObject.getData.context = context;
      messageObject.getData.no_of_messages = noOfMessages;
      messageObject.getData.oldest_message_id = oldestMessageID;

    } else { //get new messages

      url = messageObject.myGetNewMessages;
      messageObject.getData.latest_message_id = latestMessageID;

    }

    return $.ajax({
      url: url,
      type: 'get',
      data: messageObject.getData
    });
  }

  /**
   * Handles functionality when sending a message.
   * calls postMessage functions for sending the message to each participant
   * displays tick and colour change to signal to the user that the message has sent succesfully.
   * @param {string} message the message content
   * @param {string} date the date formatted as per getFormattedDate() function
   * @returns 
   */
  function sendMessage(message, date) {
    const csrf = Util.getCSRF();
    
    $.when(
      postMessage(messageObject.myPostBox, message, date, csrf).then(postMessage(messageObject.theirPostBox, message, date, csrf))
    ).done(function() {
      if (latestMessageID == 0) {
        $("#conversation-starter").remove();
      }
      //this shifts the colour of the message when it has been sent and adds an extra tick
      $(".myMessagePending").addClass("myMessage bg-primary").removeClass("myMessagePending");
      $('#sent-check-'+ messageSentCount).html('&#10003;&#10003;');
      messageSentCount++;
      enableSubmit();
    }).fail(function(error) {
      Util.toggleAlert('#error-message', error.message, 'alert-warning');
      enableSubmit();
    });

  }
  /**
   * Ajax for sending a message
   * @param {string} url the endpoint to send the message to
   * @param {string} message the message content
   * @param {string} date the date formatted as per getFormattedDate() function
   * @param {string} csrf csrf token
   * @returns
   */
  let postMessage = function(url, message, date, csrf) {
      messageObject.postData.journal_time_sent = date;
      messageObject.postData.journal_content = message;
      messageObject.postData.tag = app;

      return $.ajax({
        headers: {
          'x-csrf-token': csrf
        },
        url: url,
        type: 'post',
        data: messageObject.postData
      });
  }

  return {
    init: init
  }

}());
/**
 * two functions (disableSubmit, enableSubmit) that control the order that messages get sent - 
 * i.e. keeps them in the right order (given the async nature of the sendMessage function).
 * Testing shows this is imperceptible to the user
 */
// disabling submit button
let disableSubmit = function () {
  $(".form-chat textarea").on("keypress", function(event) {
    return true;
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }
  });

  $('form.chat input[type="submit"]').prop('disabled', true);
}
// enabling submit button
let enableSubmit = function () {
  $(".form-chat textarea").on("keypress", function(event) {
    return true;
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }
  });

  $('form.chat input[type="submit"]').prop('disabled', false);
}
/**
 * Takes a Date object and formats it.
 * 'en-GB' is hard-coded here, in future this could be passed as a parameter
 * and get the location of the message owner, perhaps set in their preferences?
 * @param {*} date javascript date object 
 * @returns 
 */
let getFormattedDate = function (date) {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  };

  return date.toLocaleString('en-GB', options);
};
/**
 * Returns formatted message.
 * Checks message length and shortens if necessary
 * Checks the message word by word by calling the checkIsURL()
 * @param {string} message the whole message to be processed
 * @param {integer} id id of the message
 * @returns 
 */
let formatMessage = function (message, id, sentMessage=false) {
  let maxLength = 240;
  let messageTextData = {
    fullMessage: "",
    shortMessage: ""
  }

  const wordsInMessage = message.split(" ");
  let convertedMessage = "";

  for(const element of wordsInMessage) {
    convertedMessage += checkIsURL(element) + " ";
  }

  messageTextData.fullMessage = convertedMessage;
  if (convertedMessage.length > maxLength) {
    let elementID = "long-message-";
    if(sentMessage) {
      elementID += "sent-"
    }
    messageTextData.shortMessage = convertedMessage.slice(0, maxLength) + '...<p id="' + elementID + id + '" class="long-message text-dark"><strong>Read more</strong></p>';
  }

  return messageTextData;
};

/**
 * Replaces shortened message with full message in UI.
 * @param {string} fullMessage the full message to be displayed
 * @param {string} messageID id of the element containing the message to be targeted 
 */
let showLongMessage = function (fullMessage, messageID) {
  $(messageID).children('p').remove();
  $(messageID).append('<p class="m-0">' + fullMessage + '</p>');
};

/**
 * Checks each word in the message to see if it's a url
 * if it is, it will convert that bit of text to an <a> tag with href.
 * @param {string} text a single word to process
 * @returns 
 */
let checkIsURL = function (text) {
  const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
  '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator

  if (urlPattern.test(text)) {
    if (text.startsWith("https://")){
      return '<a href="' + text + '" target="_blank" rel="noopener noreferrer">' + text + '</a>';
    } else {
      return '<a href="https://' + text + '" target="_blank" rel="noopener noreferrer">' + text + '</a>';
    }
  } else {
    return text;
  }
};

/**
 * Appends message to UI
 * Colour set to secondary colour and changes to primary colour once sent.
 * Likewise a single tick is added, then a second tick is added once message has been sent
 * @param {string} date the date to be added to the html
 * @param {string} message the message text to be added to the html
 * @param {number} messageSentCount a number that increments with each new message sent. Here it is added to the id of the .sent-check- element in order to make each new sent 
 * message have a unique id. This in turn provides the unique id so that a second tick can be added to the correct element indicating that the message has been sent.
 * @returns 
 */
let appendSentMessage = function (date, message, messageSentCount) {
  const messageTextData = formatMessage(message, messageSentCount, true);
  let messageText = "";
  if (!messageTextData.shortMessage) {
    messageText = messageTextData.fullMessage;
  } else {
    messageText = messageTextData.shortMessage;
  }

  $('form.chat div.messages').append(
            '<div class="message"><div id="sent-message-' + messageSentCount + '" class="myMessagePending text-white p-2 pl-3 pr-3 mr-0 ml-auto mb-4"><p class="m-0">' 
            + messageText + '</p><date class="text-dark position-absolute"><small>' 
            + date + '</small></date><div class="float-right text-primary pt-1"><small id="sent-check-'
            + messageSentCount +'">&#10003;</small></div></div></div>'
  );
  if (messageText.includes('long-message')) {
    const messageID = "#sent-message-" + messageSentCount;
    $('#long-message-sent-' + messageSentCount).on("click", function () {
      showLongMessage(messageTextData.fullMessage, messageID);
    });
  }
}

/**
 * Displays a message in the UI 
 * Passes each element to be formatted and processed for long vs short messages
 * Adds the processed message to the UI in the correct order depending on if the message is new or old
 * Adds event handler to show long messages
 * @param {*} element an element/single message passed from the messages in the response
 * @param {string} me identifies who the message is from, again passed from the response as response.me, or left as an empty string in the case of a new message received
 * @param {boolean} olderMessage defaults to false - used to determine the order that the messages should be added to the UI prepend vs append
 */
let displayMessage = function (element, me, olderMessage=false) {
  const date = getFormattedDate(new Date(element['journal_time_sent']*1000));
  const messageTextData = formatMessage(element['journal_content'], element['id']);
  let messageText = "";
  if (!messageTextData.shortMessage) {
    messageText = messageTextData.fullMessage;
  } else {
    messageText = messageTextData.shortMessage;
  }

  const myMessage = '<div class="message"><div id="message-' + element['id'] + '" class="myMessage bg-primary text-white p-2 pl-3 pr-3 mr-0 ml-auto mb-4"><p class="m-0">' 
                      + messageText + '</p><date class="text-dark position-absolute"><small>' 
                      + date + '</small></date></div></div>';
  const theirMessage = '<div class="message"><div id="message-' + element['id'] + '" class="theirMessage text-dark p-2 pl-3 pr-3 ml-0 mr-auto mb-4"><p class="m-0">' 
                          + messageText + '</p><date class="text-dark position-absolute"><small>' 
                          + date + '</small></date></div></div>';

  if (olderMessage) {
    if (element['journal_by'] == me) {
      $('form.chat div.messages').prepend(myMessage);
    } else {
      $('form.chat div.messages').prepend(theirMessage);
    }
  } else {
    if (element['journal_by'] == me) {
      $('form.chat div.messages').append(myMessage);
    } else {
      $('form.chat div.messages').append(theirMessage);
    }
  } 
  
  //if the formatted message has the class 'long-message', we add the click event handler to the relevant element (see formatMessage function where this is constructed)
  if (messageText.includes('long-message')) {
    const messageID = "#message-" + element['id'];
    $('#long-message-' + element['id']).on("click", function () {
      showLongMessage(messageTextData.fullMessage, messageID);
    });
  }
  
}

